<template>
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
  >
    <path d="M5.00001 13C4.58579 13 4.25001 12.6642 4.25001 12.25V3.46302L1.30894 6.75009C1.03274 7.05878 0.5586 7.08512 0.249911 6.80893C-0.0587779 6.53273 -0.0851194 6.05859 0.191076 5.7499L4.44107 0.999904C4.58335 0.840887 4.78663 0.75 5 0.75C5.21338 0.75 5.41666 0.840886 5.55894 0.999904L9.80894 5.7499C10.0851 6.05859 10.0588 6.53273 9.7501 6.80893C9.44142 7.08512 8.96727 7.05878 8.69108 6.75009L5.75001 3.46302V12.25C5.75001 12.6642 5.41422 13 5.00001 13Z" />
  </svg>
</template>
